'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabList = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styles = require('@material-ui/core/styles');

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabList = exports.TabList = function (_React$Component) {
  (0, _inherits3.default)(TabList, _React$Component);

  function TabList() {
    (0, _classCallCheck3.default)(this, TabList);
    return (0, _possibleConstructorReturn3.default)(this, (TabList.__proto__ || (0, _getPrototypeOf2.default)(TabList)).apply(this, arguments));
  }

  (0, _createClass3.default)(TabList, [{
    key: 'render',
    // see flow docs https://flow.org/en/docs/react/refs/

    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childMap = _props.childMap,
          children = _props.children,
          classes = _props.classes,
          onNavigate = _props.onNavigate,
          showAccent = _props.showAccent;


      return React.createElement(
        'ul',
        {
          className: classes.list,
          ref: function ref(el) {
            _this2.list = el;
          }
        },
        childMap.map(function (tabProps) {
          return React.createElement(_Tab2.default, {
            key: tabProps.index,
            onNavigate: onNavigate,
            showAccent: showAccent,
            children: tabProps.children,
            isRambling: tabProps.isRambling,
            index: tabProps.index,
            to: tabProps.to
          });
        }),
        children && React.createElement(
          'li',
          { className: classes.listItem },
          children
        )
      );
    }
  }]);
  return TabList;
}(React.Component);

TabList.defaultProps = {
  classes: {}
};


var styleSheet = function styleSheet(theme) {
  return {
    list: (0, _defineProperty3.default)({
      margin: '0 0 0 ' + _constants.NAV_INSET_MAP.MD + 'px',
      display: 'flex',
      paddingLeft: 0

    }, theme.breakpoints.down('sm'), {
      margin: '0 0 0 ' + _constants.NAV_INSET_MAP.SM + 'px'
    }),
    listItem: {
      listStyle: 'none'
    }
  };
};

exports.default = (0, _styles.withStyles)(styleSheet)(TabList);